module.exports = __webpack_public_path__ + "img/anke-s.fd982053.jpeg";